import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _dabb17a0 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _3dff28a8 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _64ba92cb = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _358e31f3 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _54eb6e93 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _4212c2fa = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _92b107fe = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _26070ec8 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _3b81ab25 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _6d5e3646 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _3f1bd2cc = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _32092336 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _bce0c688 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _4bd64a13 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _1f084b6a = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _271e8076 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _306f81dd = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _0ab9aed3 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _c452a9b0 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _c1cc0af0 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _3359c27d = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _db5f2e82 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _423a439a = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _d5bb874c = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _0d6256a0 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _a16d4ef6 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _1a8e3307 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _d5e91f4a = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _207df7f9 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _0497da0f = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _c49e5f74 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _0111d307 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _69961762 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _915ab9cc = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _d1e7bd48 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _e64855f0 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _0aa180ba = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _fecb700a = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _3ea96863 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _0f2d292d = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _2bcb93ad = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _6b77ba79 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _30b569b4 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _4c741a72 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _0405160a = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _3c0f9fd4 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _0411e7c0 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _03341a4c = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _1ff99b3c = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _343c325c = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _c894ca4e = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _e0a21fbe = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _c860c9c4 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _1d575810 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _46db017a = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _408a20b0 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _8a8f660a = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _20da8f84 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _0d865861 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _9234bc68 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _1c438ca0 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _5ddfcd83 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _2db2eb6c = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _44fab7fc = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _c182626a = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _68c07ad0 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _d256681a = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _aebeaa22 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _b8cc0c8a = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _0d4b9a66 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _722e10fc = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _9b4b8da8 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _533c5a80 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _78f7c3ee = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _5ab0296c = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _265b09c4 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _dabb17a0,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _3dff28a8,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _64ba92cb,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _358e31f3,
    name: "calendar"
  }, {
    path: "/customer",
    component: _54eb6e93,
    name: "customer"
  }, {
    path: "/details",
    component: _4212c2fa,
    name: "details"
  }, {
    path: "/goals",
    component: _92b107fe,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _26070ec8,
    name: "maisoku"
  }, {
    path: "/media",
    component: _3b81ab25,
    name: "media"
  }, {
    path: "/privacy",
    component: _6d5e3646,
    name: "privacy"
  }, {
    path: "/project",
    component: _3f1bd2cc,
    name: "project"
  }, {
    path: "/response",
    component: _32092336,
    name: "response"
  }, {
    path: "/sale",
    component: _bce0c688,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _4bd64a13,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _1f084b6a,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _271e8076,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _306f81dd,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _0ab9aed3,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _c452a9b0,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _c1cc0af0,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _3359c27d,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _db5f2e82,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _423a439a,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _d5bb874c,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _0d6256a0,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _a16d4ef6,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _1a8e3307,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _d5e91f4a,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _207df7f9,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _0497da0f,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _c49e5f74,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _0111d307,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _69961762,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _915ab9cc,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _d1e7bd48,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _e64855f0,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _0aa180ba,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _fecb700a,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _3ea96863,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _0f2d292d,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _2bcb93ad,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _6b77ba79,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _30b569b4,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _4c741a72,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _0405160a,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _3c0f9fd4,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _0411e7c0,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _03341a4c,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _1ff99b3c,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _343c325c,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _c894ca4e,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _e0a21fbe,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _c860c9c4,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _1d575810,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _46db017a,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _408a20b0,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _8a8f660a,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _20da8f84,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _0d865861,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _9234bc68,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _1c438ca0,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _5ddfcd83,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _2db2eb6c,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _44fab7fc,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _c182626a,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _68c07ad0,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _d256681a,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _aebeaa22,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _b8cc0c8a,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _0d4b9a66,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _722e10fc,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _9b4b8da8,
    name: "property-property",
    children: [{
      path: "contact",
      component: _533c5a80,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _78f7c3ee,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _5ab0296c,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _265b09c4,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
